export const CHECKOUT_SHIPPING_UI = {
    CREATE_ADDRESS_MODAL_TITLE: "Create new address",
} as const;

export const CHECKOUT_SHIPPING_MESSAGES = {
    UNABLE_TO_PROCEED_TO_PAYMENT: "Unable to proceed to payment.",
    CONSOLIDATED_FEED_MOV_NOT_MET:
        "Add more products to reach the consolidated feed minimum order value.",
} as const;

export const CHECKOUT_SHIPPING_REFETCH_QUERIES = [
    "GetOrderForCheckout",
    "GetActiveOrder",
] as const;
